
































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import { IClient } from "@/models/clients";
import { UserMetaKeys } from "@/data/enums/users";
import { ListDisplayMode } from "@/data/constants";
import { CreateElement } from "vue";
// Components
import CProdsProvider from "@/components/app/global/contractProducts/cProdsProvider.vue";
import CProdsGridView from "@/components/app/global/contractProducts/cProdsGridView.vue";
import CProdsTableView from "@/components/app/global/contractProducts/cProdsTableView.vue";
import { IContractProduct } from "@/models/contracts";

@Component({
  components: {
    "cprods-provider": CProdsProvider,
    CProdsGridView,
    CProdsTableView
  }
})
export default class CProdsListing extends Vue {
  // Props

  @Prop({ default: null })
  public clientId!: IClient["id"];

  @Prop({ default: () => () => ({}) })
  public routeFilters!: (
    vm?: CProdsListing
  ) => Record<string, string | number | boolean>;

  @Prop({ default: () => ({}) })
  public parentFilters!: Record<string, string | number | boolean>;

  @Prop({ default: () => () => [] })
  public availableFilters!: (vm?: CProdsListing) => IFilter[];

  @Prop({ default: () => () => [] })
  public availableSorters!: (vm?: CProdsListing) => ISorter[];

  @Prop({ default: undefined })
  public rowTag!: string;

  @Prop({ default: () => () => ({}) })
  public rowEvents!: (
    contractProduct: IContractProduct
  ) => { [key: string]: Function };

  @Prop({ default: undefined })
  public forceDisplayMode!: ListDisplayMode;

  @Prop({ default: undefined })
  public client!: IClient;

  // Data
  public displayModeStoragePath = UserMetaKeys.UI_CPRODS_VIEW;
  public displayMode = ListDisplayMode.GRID;

  public cProdAvailableFilters: IFilter[] = [];

  public declare $refs: {
    cProdsProvider: CProdsProvider;
  };

  // Life-cycle methods
  public created() {
    this.cProdAvailableFilters = this.availableFilters(this);
  }

  // Computed

  public get displayModeComputed() {
    return this.forceDisplayMode || this.displayMode;
  }

  public get cProdManualFilters() {
    return {
      ...this.parentFilters,
      ...this.routeFilters(this)
    };
  }

  public get cProdAvailableSorters() {
    return this.availableSorters(this);
  }

  public get listComponent() {
    return {
      render: (h: CreateElement) => {
        if (this.displayModeComputed === ListDisplayMode.GRID)
          return h(CProdsGridView);
        return h(CProdsTableView, {
          props: {
            id: "ACPTV" /* Admin Contract Products Table View*/,
            clientId: this.clientId,
            rowTag: this.rowTag,
            rowEvents: this.rowEvents
          }
        });
      }
    };
  }

  public get isStaged() {
    return this.client?.staged_import ?? false;
  }

  @Watch("parentFilters", { deep: true })
  public onParentFiltersChange() {
    this.$refs.cProdsProvider.reloadData();
  }
}
